import React from 'react'

import { Skeleton } from 'antd'
import {
  CardText,
  CardValue,
  SingleCard,
} from 'components/InfoCardsUpdate/style'
import { IconTextContainer, TextWrapper } from './style'

const InfoCardsUpdate = ({
  background,
  padding = '15px 25px',
  width = 'auto',
  icon,
  text,
  value,
  onClick,
  isSelected = false,
  borderColor,
  loading,
  IconText,
}) => {
  return (
    <SingleCard
      data-test={background}
      background={background}
      padding={padding}
      width={width}
      column
      flexStart
      onClick={onClick}
      borderColor={borderColor}
    >
      <IconTextContainer>
        {icon}
        {IconText && <TextWrapper>{IconText}</TextWrapper>}
      </IconTextContainer>
      <CardText isSelected={isSelected}>{text}</CardText>
      {loading ? (
        <Skeleton.Avatar active={true} size={'default'} shape={'square'} />
      ) : (
        <CardValue isSelected={isSelected}>{value}</CardValue>
      )}
    </SingleCard>
  )
}

export default InfoCardsUpdate